const topics = [
  { icon: 'ri-movie-2-line', title: '最新电影', desc: '院线大片抢先看，每周更新热门新片资源', color: 'primary' },
  { icon: 'ri-tv-2-line', title: '热门电视剧', desc: '高分剧集全集放送，国产剧韩剧美剧全覆盖', color: 'accent' },
  { icon: 'ri-emotion-laugh-line', title: '综艺节目', desc: '爆笑不停档，热门综艺第一时间更新', color: 'secondary' },
  { icon: 'ri-rocket-2-line', title: '动漫专区', desc: '热血番剧追不停，日漫国漫一网打尽', color: 'primary' },
  { icon: 'ri-earth-line', title: '纪录片', desc: '探索世界真相，BBC、NHK精品纪录片合集', color: 'accent' },
  { icon: 'ri-heart-2-line', title: '韩剧专场', desc: '浪漫爱情全收录，热门韩剧同步追更', color: 'secondary' },
  { icon: 'ri-flag-2-line', title: '美剧精选', desc: '品质剧集一网打尽，经典美剧全季收录', color: 'primary' },
  { icon: 'ri-building-2-line', title: '港剧经典', desc: '重温TVB黄金时代，经典港剧全程回味', color: 'accent' },
];

const colorMap: Record<string, { bg: string; icon: string; text: string }> = {
  primary: { bg: 'bg-primary-50', icon: 'text-primary-600', text: 'text-primary-700' },
  accent: { bg: 'bg-accent-50', icon: 'text-accent-600', text: 'text-accent-700' },
  secondary: { bg: 'bg-secondary-50', icon: 'text-secondary-600', text: 'text-secondary-700' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            热门专题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">按分类快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto">
          {topics.map((item) => {
            const c = colorMap[item.color];
            return (
              <a
                key={item.title}
                href="#index"
                className={`group flex flex-col items-center text-center p-5 md:p-6 rounded-xl ${c.bg} transition-all hover:scale-[1.03] cursor-pointer`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50 mb-3`}>
                  <i className={`${item.icon} text-xl md:text-2xl ${c.icon}`}></i>
                </div>
                <h3 className={`font-heading font-semibold text-sm md:text-base ${c.text} mb-1`}>
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed hidden md:block">
                  {item.desc}
                </p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}